function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.149,
  y1: 0.159,
  x2: 0.767,
  y2: 0.853,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#001b2b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#046d64"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Path_124",
  x: 0,
  y: 0,
  width: 293.283,
  height: 293.182,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#004321",
  floodOpacity: 0.239
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "true-mark",
  transform: "translate(70.058 44.834) rotate(8)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.99, -0.14, 0.14, 0.99, -75.62, -34.65)",
  filter: "url(#Path_124)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_124-2",
  "data-name": "Path 124",
  d: "M90,0A89.941,89.941,0,1,1,0,89.941,89.97,89.97,0,0,1,90,0Z",
  transform: "translate(70.03 45) rotate(8)",
  fill: "url(#linear-gradient)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_123",
  "data-name": "Path 123",
  d: "M156.985,225.058l-42.553-33.151,12.1-15.528,26.131,20.357L195.789,134.5l16.183,11.211Z",
  transform: "translate(-74.202 -87.108)",
  fill: "#fff"
}));

function SvgTrueMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 293.283,
    height: 293.182,
    viewBox: "0 0 293.283 293.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueMark);
export default __webpack_public_path__ + "static/media/true-mark.cabb17ef.svg";
export { ForwardRef as ReactComponent };